// client/src/routes/app/properties/$propertyId/equipment.tsx — SCR-PROP-003 tab „Echipamente"
// (D-2840).
//
// SCR-EQP-001's register with the property pinned, calendar view included: the apartment's
// installations and their revisions. `Operations.Read`, as the register's own route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { EquipmentRegister } from '@/features/equipment/EquipmentRegister';
import { equipmentSearchSchema, type EquipmentSearch } from '@/features/equipment/search';

export const Route = createFileRoute('/app/properties/$propertyId/equipment')({
  validateSearch: equipmentSearchSchema,
  component: EquipmentRegisterTab,
});

function EquipmentRegisterTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <EquipmentRegister
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: EquipmentSearch) => EquipmentSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
